// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventoryContent {
  /* position: fixed;
  top: 10;
  left: 0; */
  width: 100%;
  /* display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 0.5rem 1rem; */
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  background-color: #ffffff;
  z-index: 1000;
  height: 100vh;
  /* padding-left:10px;
  padding-right:10px; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/IssueDetails.css"],"names":[],"mappings":"AAAA;EACE;;YAEU;EACV,WAAW;EACX;;;yBAGuB;EACvB,8CAA8C;EAC9C,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb;uBACqB;AACvB","sourcesContent":[".inventoryContent {\n  /* position: fixed;\n  top: 10;\n  left: 0; */\n  width: 100%;\n  /* display: flex;\n  justify-content: space-between;\n  align-items: start;\n  padding: 0.5rem 1rem; */\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n  background-color: #ffffff;\n  z-index: 1000;\n  height: 100vh;\n  /* padding-left:10px;\n  padding-right:10px; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
